import date from 'locutus/php/datetime/date'

export default function parseDate(input, format) {
  if (input === '' || input === null) return null
  
  format = format || 'yyyy-mm-dd'; // default format
  var parts = input.match(/(\d+)/g), 
      i = 0, fmt = {};
  
  // extract date-part indexes from the format
  format.replace(/(yyyy|dd|mm)/g, function(part) { fmt[part] = i++; });
  
  if (parts[fmt['yyyy']] > 1000 && parts[fmt['yyyy']] <= 9999 && parts[fmt['mm']] >= 1 && parts[fmt['mm']] <= 12 && parts[fmt['dd']] >= 1 && parts[fmt['dd']] <= date('t', parts[fmt['yyyy']] + '-' + parts[fmt['mm']] + '-01')) {
    return new Date(parts[fmt['yyyy']], parts[fmt['mm']]-1, parts[fmt['dd']]);
  }

  return false
}